import DOMPurify from 'dompurify';

function removeAttribute(name, node) {
  try {
    DOMPurify.removed.push({
      attribute: node.getAttributeNode(name),
      from: node,
    });
  } catch (error) {
    DOMPurify.removed.push({
      attribute: null,
      from: node,
    });
  }

  node.removeAttribute(name);
}

// NOTE: DOMPurify 会反转属性顺序 https://tower.im/teams/630713/todos/14045/
DOMPurify.addHook('afterSanitizeAttributes', (currentNode) => {
  const { attributes } = currentNode;
  if (!attributes) return;

  let l = attributes.length;
  let attr;

  while (l) {
    l -= 1;
    attr = attributes[l];

    removeAttribute(attr.name, currentNode);
    currentNode.setAttribute(attr.name, attr.value);
  }
});

export default DOMPurify;
